import invert from "lodash/invert";

export enum ViewNames {
  ContactDetails = 0,
  UserDetails = 1,
  ScheduleDemo = 2
}

export enum ViewNamesTwoSteps {
  AllDetails = 0,
  ScheduleDemo = 1
}

export const PARAM_TO_VIEW_MAP = {
  "personal-info": ViewNames.ContactDetails,
  "company-info": ViewNames.UserDetails
};

export const PARAM_TO_VIEW_MAP_TWO_STEPS = {
  "personal-info": ViewNamesTwoSteps.AllDetails,
  "schedule-demo": ViewNamesTwoSteps.ScheduleDemo
};

export const VIEW_TO_PARAM_MAP = invert(PARAM_TO_VIEW_MAP) as Record<number, string>;

export type StepId = keyof typeof PARAM_TO_VIEW_MAP;
